import { FC } from 'react';
import {
  GroupDescriptionType,
  InputDataDetailsType,
  ObjectHeader,
  Padding,
  TextDisabled,
} from '@atlas-frontend/sdk';
import { AppLink } from '../../../../common/AppLink';

interface InputDataSubjectDetailLeftSideHeaderProps {
  inputDataDetailsType?: InputDataDetailsType;
  description?: GroupDescriptionType;
}
export const InputDataSubjectDetailLeftSideHeader: FC<
  InputDataSubjectDetailLeftSideHeaderProps
> = (props) => {
  const { description, inputDataDetailsType } = props;
  return (
    <Padding>
      <ObjectHeader
        upperText={
          !description?.code ? undefined : description.activeVersionId ? (
            <AppLink
              id={`description-${description.code}`}
              to={`/data-dictionary/input-data-objects/${description.activeVersionId}`}
            >
              {`${description?.code} - ${description?.name}`}
            </AppLink>
          ) : (
            <TextDisabled>{`${description?.code} - ${description?.name}`}</TextDisabled>
          )
        }
        lowerText={
          inputDataDetailsType?.dataSubjectCode ? (
            <AppLink
              id={`subject-${inputDataDetailsType.dataSubjectCode}`}
              to={`/data/data-subjects/${inputDataDetailsType.dataSubjectId}`}
            >
              {`${inputDataDetailsType.dataSubjectCode} - ${inputDataDetailsType.dataSubjectName}`}
            </AppLink>
          ) : undefined
        }
        upperPlaceholder={''}
        lowerPlaceholder={''}
      />
    </Padding>
  );
};
